<template>
<!-- 对外宣传 需要 detail + 透镜跳转 -->
    <detail :pageType="1"></detail>
</template>

<script>

import Detail from "@/components/position/detail";
export default {
  name: "positions-module",
  components: {
    Detail
  },
  methods: {},
  created() {}
};
</script>
